import React from 'react';
import { Text, Box } from '@mantine/core';
import classes from './MarkdownComponents.module.css';

// -----------------------------------------------------------------------------
export const createMarkdownComponents = (
  customClasses?: Record<string, string>
) => {
  const mergedClasses = { ...classes, ...customClasses };

  // ---------------------------------------------------------------------------
  return {
    h1: ({ children }: any) => (
      <Text size="lg" fw={700} className={mergedClasses.heading1}>
        {children}
      </Text>
    ),
    h2: ({ children }: any) => (
      <Text size="md" fw={600} className={mergedClasses.heading2}>
        {children}
      </Text>
    ),
    h3: ({ children }: any) => (
      <Text size="sm" fw={600} className={mergedClasses.heading3}>
        {children}
      </Text>
    ),
    p: ({ children }: any) => (
      <Text size="sm" className={mergedClasses.paragraph}>
        {children}
      </Text>
    ),
    ul: ({ children }: any) => (
      <ul className={mergedClasses.unorderedList}>{children}</ul>
    ),
    ol: ({ children }: any) => (
      <ol className={mergedClasses.orderedList}>{children}</ol>
    ),
    li: ({ children }: any) => (
      <li className={mergedClasses.listItem}>
        <Text size="sm">{children}</Text>
      </li>
    ),
    strong: ({ children }: any) => (
      <Text span fw={600}>
        {children}
      </Text>
    ),
    em: ({ children }: any) => (
      <Text span fs="italic">
        {children}
      </Text>
    ),
    code: ({ children, className }: any) => {
      // Handle code blocks vs inline code
      if (className?.includes('language-')) {
        return (
          <Box component="pre" className={mergedClasses.codeBlock}>
            <Box component="code">{children}</Box>
          </Box>
        );
      } else {
        return (
          <Text
            span
            ff="monospace"
            size="sm"
            className={mergedClasses.inlineCode}
          >
            {children}
          </Text>
        );
      }
    },
    blockquote: ({ children }: any) => (
      <div className={mergedClasses.blockquote}>
        <Text size="sm">{children}</Text>
      </div>
    ),
    table: ({ children }: any) => (
      <table className={mergedClasses.table}>{children}</table>
    ),
    th: ({ children }: any) => (
      <th className={mergedClasses.tableHeader}>
        <Text size="sm">{children}</Text>
      </th>
    ),
    td: ({ children }: any) => (
      <td className={mergedClasses.tableCell}>
        <Text size="sm">{children}</Text>
      </td>
    ),
  };
};

// -----------------------------------------------------------------------------
export const defaultMarkdownComponents = createMarkdownComponents();
